'use strict';

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
Object.defineProperty(exports, '__esModule', {
	value: true
});
exports.WalletMenuItemLogOut =
	exports.WalletMenuItemCopy =
	exports.WalletMenuItemChange =
	exports.WalletMenuItem =
	exports.WalletMenu =
	exports.ConnectWrapper =
		void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require('@babel/runtime/helpers/taggedTemplateLiteral'));
var _styledComponents = _interopRequireDefault(require('styled-components'));
var _IoWalletOutline = require('@react-icons/all-files/io5/IoWalletOutline');
var _IoLogOutOutline = require('@react-icons/all-files/io5/IoLogOutOutline');
var _IoCopyOutline = require('@react-icons/all-files/io5/IoCopyOutline');
var _colors = require('../../utils/colors');
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var ConnectWrapper = (exports.ConnectWrapper = _styledComponents['default'].div(
	_templateObject || (_templateObject = (0, _taggedTemplateLiteral2['default'])(['\n\tposition: relative;\n']))
));
var WalletMenu = (exports.WalletMenu = _styledComponents['default'].div(
	_templateObject2 ||
		(_templateObject2 = (0, _taggedTemplateLiteral2['default'])([
			'\n\tposition: absolute;\n\tdisplay: flex;\n\tflex-direction: column;\n\ttop: 46px;\n\tright: 0;\n\tpadding: 12px;\n\tgap: 12px;\n\tbackground-color: ',
			';\n\tborder-radius: 4px;\n\tborder: #2c2c2c22 solid 1px;\n'
		])),
	function (props) {
		return props.theme.backgroundColor || '#F1F1F1';
	}
));
var WalletMenuItem = (exports.WalletMenuItem = _styledComponents['default'].div(
	_templateObject3 ||
		(_templateObject3 = (0, _taggedTemplateLiteral2['default'])([
			'\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n\tfont-weight: 500;\n\tfont-size: 1.15rem;\n\twhite-space: nowrap;\n\tcolor: ',
			';\n\tcursor: pointer;\n\tborder-radius: 6px;\n\tpadding: 9px;\n\n\t&:hover {\n\t\tbackground-color: ',
			';\n\t}\n'
		])),
	function (props) {
		return props.theme.primaryColor || '#121212';
	},
	function (props) {
		return (0, _colors.addOpacityToColor)(props.theme.primaryColor || '#121212', 0.32);
	}
));
var WalletMenuItemChange = (exports.WalletMenuItemChange = (0, _styledComponents['default'])(_IoWalletOutline.IoWalletOutline)(
	_templateObject4 ||
		(_templateObject4 = (0, _taggedTemplateLiteral2['default'])(['\n\twidth: 20px;\n\theight: 20px;\n\tcolor: ', ';\n\tfill: ', ';\n\tstroke: ', ';\n'])),
	function (props) {
		return props.theme.primaryColor || '#121212';
	},
	function (props) {
		return props.theme.primaryColor || '#121212';
	},
	function (props) {
		return props.theme.primaryColor || '#121212';
	}
));
var WalletMenuItemCopy = (exports.WalletMenuItemCopy = (0, _styledComponents['default'])(_IoCopyOutline.IoCopyOutline)(
	_templateObject5 ||
		(_templateObject5 = (0, _taggedTemplateLiteral2['default'])(['\n\twidth: 20px;\n\theight: 20px;\n\tcolor: ', ';\n\tfill: ', ';\n\tstroke: ', ';\n'])),
	function (props) {
		return props.theme.primaryColor || '#121212';
	},
	function (props) {
		return props.theme.primaryColor || '#121212';
	},
	function (props) {
		return props.theme.primaryColor || '#121212';
	}
));
var WalletMenuItemLogOut = (exports.WalletMenuItemLogOut = (0, _styledComponents['default'])(_IoLogOutOutline.IoLogOutOutline)(
	_templateObject6 ||
		(_templateObject6 = (0, _taggedTemplateLiteral2['default'])(['\n\twidth: 20px;\n\theight: 20px;\n\tcolor: ', ';\n\tfill: ', ';\n\tstroke: ', ';\n'])),
	function (props) {
		return props.theme.primaryColor || '#121212';
	},
	function (props) {
		return props.theme.primaryColor || '#121212';
	},
	function (props) {
		return props.theme.primaryColor || '#121212';
	}
));
//# sourceMappingURL=styles.js.map
